@for (featureSet of featureSets; track featureSet) {
  <div class="device-card-container">
    <ds-battery-device [featureSet]="featureSet"></ds-battery-device>
  </div>
}